import { Service } from "typedi";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { AgentRPCCommandMap } from "../../../../shared/RPC/AgentRPCCommandMap";

const reason = (command: string): Error =>
    new Error(`[network-agent] command "${command}" is not supported in this agent context`);

const unsupported = <K extends keyof AgentRPCCommandMap>(name: K): AgentRPCCommand<K> => ({
    run: (async () => {
        throw reason(name as string);
    }) as AgentRPCCommand<K>["run"]
});

/**
 * Registers every command the network agent cannot fulfil with a uniform
 * "not supported" error. Keeping them here (instead of one file per command)
 * makes it obvious which surface area is currently stubbed.
 */
@Service()
export class NotSupportedCommands {
    constructor(agentRPCCommands: AgentRPCCommands) {
        agentRPCCommands.register("close.tabs", unsupported("close.tabs"));
        agentRPCCommands.register("close.windows", unsupported("close.windows"));
        agentRPCCommands.register("focus.tab", unsupported("focus.tab"));
        agentRPCCommands.register("focus.window", unsupported("focus.window"));
        agentRPCCommands.register("get.live.browser.screenshot", unsupported("get.live.browser.screenshot"));
        agentRPCCommands.register("get.device.camera.snapshot", unsupported("get.device.camera.snapshot"));
        agentRPCCommands.register("get.device.extensions", unsupported("get.device.extensions"));
        agentRPCCommands.register("start.webrtc.streaming", unsupported("start.webrtc.streaming"));
        agentRPCCommands.register("stop.webrtc.streaming", unsupported("stop.webrtc.streaming"));
        agentRPCCommands.register("get.webrtc.status", unsupported("get.webrtc.status"));
        agentRPCCommands.register("send.webrtc.signaling", unsupported("send.webrtc.signaling"));
    }
}
